import { Booking, BookingStatus, Bookings } from "@/models/booking";
import { BookingDTO, BookingsDTO } from "../dtos";
import { BookingStatusDTO } from "../dtos/booking.api.dto";

export const mapBookingDTOToBooking = (bookingDTO: BookingDTO): Booking => {
  return {
    _id: bookingDTO.id,
    roomId: bookingDTO.roomId,
    roomName: bookingDTO.roomName,
    reservationNumber: bookingDTO.reservationNumber,
    guest: {
      firstName: bookingDTO.guest.firstName,
      lastName: bookingDTO.guest.lastName,
      phone: bookingDTO.guest.phone,
      email: bookingDTO.guest.email ?? "",
      nationality: bookingDTO.guest.nationality,
      age: bookingDTO.guest.age,
    },
    booker: bookingDTO.booker
      ? {
          firstName: bookingDTO.booker.firstName,
          lastName: bookingDTO.booker.lastName,
          phone: bookingDTO.booker.phone,
          email: bookingDTO.booker.email,
          company: bookingDTO.booker.company,
        }
      : undefined,
    additionalGuests: bookingDTO.additionalGuests?.map((ag) => ({
      firstName: ag.firstName,
      lastName: ag.lastName,
      phone: ag.phone ?? "",
      email: ag.email ?? "",
      nationality: ag.nationality,
      age: ag.age,
    })),
    checkIn: new Date(bookingDTO.checkIn),
    checkOut: new Date(bookingDTO.checkOut),
    otaInfo: bookingDTO.otaInfo,
    pmsInfo: bookingDTO.pmsInfo,
    pax: bookingDTO.pax,
    cityTax: bookingDTO.cityTax,
    accessType: bookingDTO.accessType,
    keyStatus: bookingDTO.keyStatus,
    billing: bookingDTO.billing || undefined,
    status: mapBookingStatusDTOToBookingStatus(bookingDTO.status),
    additionalInfo: bookingDTO.additionalInfo,
    createdAt: new Date(bookingDTO.createdAt),
    deletedAt: bookingDTO.deletedAt ? new Date(bookingDTO.deletedAt) : undefined,
  };
};

export const mapBookingsDTOtoBookings = ({
  bookings,
  totalBookings,
  totalPages,
}: BookingsDTO["data"]): Bookings => {
  return {
    bookings: bookings.map(mapBookingDTOToBooking),
    totalPages,
    totalBookings,
  };
};

// Helper function to map BookingStatusDTO to BookingStatus
function mapBookingStatusDTOToBookingStatus(statusDTO: BookingStatusDTO): BookingStatus {
  // Adjust this mapping logic as needed based on your enums/types
  return statusDTO as unknown as BookingStatus;
}
